// import ReactDOM from 'react-dom';
import { hasMissingIdSegment } from './utils/deviceAssign';
import { createRoot } from 'react-dom/client'
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { positions, transitions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import axios from 'axios';

const _t = localStorage.getItem("token");
if (_t) { axios.defaults.headers.common["authorization"] = "Bearer " + JSON.parse(_t); }
axios.interceptors.request.use((cfg) => {
    if (hasMissingIdSegment(cfg.url)) {
        return Promise.reject(Object.assign(new Error('Missing id: request not sent'), { config: cfg, vpMissingId: true }));
    }
    return cfg;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("admin");
      localStorage.removeItem("doctor");
      localStorage.removeItem("hr");
      localStorage.removeItem("expireTime");
      if (window.location.pathname.indexOf("login") === -1) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);


const options = {
  position: positions.BOTTOM_RIGHT,
  timeout: 5000,
  offset: '30px',
  transition: transitions.FADE
}

createRoot(document.getElementById('root')).render(<Provider store={store}>
  <AlertProvider template={AlertTemplate} {...options}>
    <App />   
  </AlertProvider>
</Provider>)


// ReactDOM.render(
//   <Provider store={store}>
//     <AlertProvider template={AlertTemplate} {...options}>
//       <App />   
//     </AlertProvider>
//   </Provider>,
//   document.getElementById('root')
// );
